import { AsButton, AsText, useModal } from '@adserve/adserve-react-components';
import React, { useState, useEffect } from 'react';
import CreateQuoteCurrencyCell from './CreateQuoteCurrencyCell';
import moment from 'moment';
import CreateQuoteTickbox from './CreateQuoteTickbox';
import { GetQuoteFormats, GetQuoteOffairTotals, GetQuoteTotals } from '../../../services/CampaignsDataService';
import QuoteFormat from './QuoteFormat';

let mounted = false;

const CreateQuoteModal = ({ campaign, quoteType = '', createQuote, planId, campaignBurst = undefined }) => {
    const { removeMessage } = useModal();

    const [isLoading, setIsLoading] = useState(true);
    const [quoteFormat, setQuoteFormat] = useState(1);
    const [airtimeTotal, setAirtimeTotal] = useState(0);
    const [offairTotal, setOffairTotal] = useState(0);
    const [quoteFormats, setQuoteFormats] = useState([]);
    const [includeSignature, setIncludeSignature] = useState(false);
    const [name, setName] = useState(`${campaign.name} ${campaignBurst ? 'Airtime Burst' : quoteType} Quote ${moment().format('YYYY/MM/DD hh:mm:ss')}`);

    const getData = async () => {
        setIsLoading(true);
        const response = await GetQuoteFormats();
        if (mounted) {
            setQuoteFormats(response.data);
            setIsLoading(false);
        }
    };

    const getTotal = async () => {
        if (!planId) return; // We don't need airtime totals for off-air campaigns
        setIsLoading(true);
        const response = await GetQuoteTotals(planId);
        if (mounted) {
            setAirtimeTotal(response.data);
            setIsLoading(false);
        }
    };

    const getOffairTotal = async () => {
        setIsLoading(true);
        const response = await GetQuoteOffairTotals(campaign.id);
        if (mounted) {
            setOffairTotal(response.data);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        mounted = true;
        getTotal();
        getOffairTotal();
        getData();
        return () => {
            mounted = false;
        };
    }, []);

    const onCreateQuoteClick = async () => {
        setIsLoading(true);
        await createQuote(name, quoteFormat, includeSignature);
        if (mounted) {
            setIsLoading(false);
        }
    };

    /**
     * Event handler for AsText Quote Name box in the Create Quote modal.
     * @param {Event} event - onChange event
     */
    const onQuoteNameChange = (event) => {
        setName(event.target.value);
    };

    const onQuoteFormatChange = (id) => {
        setQuoteFormat(id);
    };

    /**
     * Click event handler for include signature page tickbox
     */
    const handleIncludeSignaturePageClick = () => {
        setIncludeSignature(!includeSignature);
    };

    // const offairTotal = campaign.offairActivities?.filter((x) => x.status !== 5).reduce((total, oa) => total + oa.price, 0) ?? 0;
    // const total = airtimeTotal + offairTotal ?? 0;

    return (
        <div
            id='createQuoteModalContent'
            style={{
                display: 'grid',
                gridAutoFlow: 'row',
                textAlign: 'left',
                gap: '2rem',
                margin: 'auto',
                width: '80%'
            }}
        >
            {/* Setting the height to 0 but leaving the overflow as visible positions the heading next to the X */}
            <div id='quoteSettingsHeadRow' style={{ position: 'relative', height: 0 }}>
                <h1
                    style={{
                        color: '#414141',
                        fontFamily: 'roboto',
                        fontSize: 22,
                        textAlign: 'center',
                        padding: 0,
                        margin: 0,
                        position: 'relative',
                        bottom: 23,
                        boxSizing: 'border-box'
                    }}
                >
                    {window.translate('Generate Quote')}
                </h1>
            </div>

            <div id='quoteNameInputRow'>
                <AsText
                    id='quoteNameInput'
                    value={name}
                    title='Quote Name *'
                    onChange={onQuoteNameChange}
                    labelStyle={{ fontFamily: 'roboto', fontSize: 12, color: '#414141', marginBottom: 5 }}
                    inputStyle={{ width: '100%', boxSizing: 'border-box', padding: 10 }}
                />
            </div>
            <div
                id='quoteModalFormGrid'
                style={{
                    display: 'grid',
                    width: '100%',
                    gap: 20,
                    gridAutoFlow: 'column',
                    gridAutoColumns: '1fr'
                }}
            >
                {/* Sub Headers */}
                <div id='leftPane' style={{ display: 'flex', gap: 20, flexDirection: 'column' }}>
                    <span>{window.translate('Quote Value')}</span>
                    {quoteType?.toLowerCase() !== 'offair' && (
                        <CreateQuoteCurrencyCell name='Total Airtime Costs' value={airtimeTotal} />
                    )}

                    <CreateQuoteCurrencyCell
                        name='Total Off-Air Costs'
                        value={offairTotal}
                    />

                    <CreateQuoteCurrencyCell name='Total This Quote' value={airtimeTotal + offairTotal ?? 0} />

                    <AsButton
                        id='createQuoteCancelButton'
                        useTertiaryStyle
                        handleClick={removeMessage}
                        style={{ margin: 'auto auto -50px auto', width: 'max-content', padding: '0 15px' }}
                    >
                        {window.translate('Cancel')}
                    </AsButton>
                </div>
                <div id='rightPane' style={{ display: 'flex', gap: 20, flexDirection: 'column' }}>
                    <span>{window.translate('Quote Format')}</span>

                    {quoteFormats.map((qf, i) => (
                        <QuoteFormat
                            key={i}
                            quoteFormat={qf}
                            value={quoteFormat === qf.id}
                            onClick={onQuoteFormatChange}
                        />
                    ))}

                    <CreateQuoteTickbox
                        id='includeSignaturePage'
                        title={window.translate('Include signature page')}
                        value={includeSignature}
                        onClick={handleIncludeSignaturePageClick}
                    />

                    <AsButton
                        id='createQuoteCreateButton'
                        handleClick={onCreateQuoteClick}
                        style={{ margin: 'auto auto -50px auto', width: 'max-content', padding: '0 15px' }}
                        disabled={isLoading}
                    >
                        {window.translate(isLoading ? 'Please wait...' : 'Create')}
                    </AsButton>
                </div>
            </div>
        </div>
    );
};

export default CreateQuoteModal;
